var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMessageOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.833 0.166656H2.16634C1.02051 0.166656 0.0934245 1.10416 0.0934245 2.24999L0.0830078 14.75C0.0830078 15.8958 1.02051 16.8333 2.16634 16.8333H18.833C19.9788 16.8333 20.9163 15.8958 20.9163 14.75V2.24999C20.9163 1.10416 19.9788 0.166656 18.833 0.166656ZM18.833 4.33332L10.4997 9.54166L2.16634 4.33332V2.24999L10.4997 7.45832L18.833 2.24999V4.33332Z",
    fill: "#051C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMessageOutlined);
export default __webpack_public_path__ + "static/media/blueMessageOutlined.9005f3eb4b864ce474551db2fb9dc184.svg";
export { ForwardRef as ReactComponent };